import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Triggers a search in a grid
 */
export class SearchGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param payload The (untyped) payload. Can also be a callback function
  */
  public handle(payload: any): void {
    this.workspace.grid.loadData({
      skip: 0,
      filter: payload
    }, this.workspace.grid?.selectedItem?.Oid);
  }
}
